import React from 'react';

import "./assets/Header.css";

function Header ({ selectedTab, setSelectedTab, userName}) {
    const menuItems = {
        Onboard: ["License", "Delta MBN"],
        Repository: ["License", "Delta MBN", "Created Solution", "Certified Solution", "Delivery Ready Solution"],
        Create: ["Group", "Solution"]
    }
    
    return (
        <div className="header">
            <div className="header-section project-name"><h4>QFM Portal</h4></div>

            <div className="header-section tabs">
                {Object.keys(menuItems).map((menu) => (
                    <div className='tab-dropdown' key={menu}>
                        <span className={`tab-name ${selectedTab.startsWith(menu) ? 'active' : ''}`}>{menu}</span>
                        <div className='dropdown-content'>
                            {menuItems[menu].map((item) => (
                                <div
                                key={item}
                                className='dropdown-item'
                                onClick={() => setSelectedTab(`${menu}/${item}`)}
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>


            <button className="user-icon-btn"></button>
            <div className="header-section user-info">
                <div>Welcome,</div>
                <div>{userName}</div>
            </div>

        </div>
    );
};

export default Header;